import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { IClientFieldsVisibility } from '@app/core/model/env-config.model';
import { SigningRequestChannel } from 'ngx-mat-esign360';
import { isClientFieldVisible } from '../utils/form.util';

export function VisibleClientFieldsValidator(
  clientFieldsVisibility: IClientFieldsVisibility
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const formGroup = control as FormGroup;
    const birthYearControl = formGroup.get('birthYear');
    const signingRequestSubjectControl = formGroup.get('signingRequest').get('subject');
    const signingRequestBodyControl = formGroup.get('signingRequest').get('body');

    updateClientFieldErrors(clientFieldsVisibility, birthYearControl, 'birthYear');

    updateClientFieldErrors(
      clientFieldsVisibility,
      signingRequestSubjectControl,
      'signingRequestSubject'
    );

    updateClientFieldErrors(
      clientFieldsVisibility,
      signingRequestBodyControl,
      'signingRequestBody'
    );

    return null;
  };
}

function isClientFieldRequired(
  clientFieldsVisibility: IClientFieldsVisibility,
  control: AbstractControl,
  fieldName: keyof IClientFieldsVisibility
): boolean {
  if (fieldName === 'signingRequestBody' || fieldName === 'signingRequestSubject') {
    const channel: SigningRequestChannel = control.parent.get('channel').value;

    return (
      channel !== SigningRequestChannel.None &&
      (fieldName === 'signingRequestBody' || channel === SigningRequestChannel.Email) &&
      isClientFieldVisible(clientFieldsVisibility, fieldName)
    );
  }

  return isClientFieldVisible(clientFieldsVisibility, fieldName);
}

function updateClientFieldErrors(
  clientFieldsVisibility: IClientFieldsVisibility,
  control: AbstractControl,
  fieldName: keyof IClientFieldsVisibility
): void {
  if (isClientFieldRequired(clientFieldsVisibility, control, fieldName)) {
    const requiredError = Validators.required(control);

    if (requiredError) {
      control.setErrors({
        ...(control.errors ?? {}),
        ...requiredError,
      });
    } else {
      control.updateValueAndValidity({ onlySelf: true });
    }
  } else {
    control.updateValueAndValidity({ onlySelf: true });
  }
}
